import { CONFIG } from "../config";

export function buildDocumentTitle(title, selectedOrganisation) {
  const safeTitle = title || CONFIG.siteTitle;
  const orgPrefix = selectedOrganisation?.name
    ? `${selectedOrganisation.name} `
    : "";

  return `${orgPrefix}${safeTitle} | ${CONFIG.siteTitle} - ${CONFIG.siteTitleDescription}`;
}
